import { AuthService } from './core/services/auth.service';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { TestDeviceComponent } from './test-device/test-device.component';
import { LaneClosedComponent } from './lane-closed/lane-closed.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorStoreIdMissingComponent } from './error-storeid-missing/error-storeid-missing.component';
import { LocaleService } from '@shared/services/locale.service';
import { VersionService } from '@core/services/version.service';
import { ThemeService } from '@shared/services/theme.service';
import { VideoOverlayService } from '@shared/components/video-overlay/video-overlay.service';
import { RouteAnimationsService } from '@shared/services/route-animations.service';
import { SanityCheckService } from '@core/services/sanity-check.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IoService } from '@core/services/io.service';

export function initApp(authService: AuthService) {
  return authService.verifyActiveSession;
}

@NgModule({
  declarations: [AppComponent, TestDeviceComponent, LaneClosedComponent, ErrorStoreIdMissingComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
  ],
  providers: [
    LocaleService,
    IoService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthService, VersionService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: VersionService) => () => svc.load(),
      deps: [VersionService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: SanityCheckService) => () => svc.runAll(),
      deps: [SanityCheckService],
      multi: true,
    },
    ThemeService,
    VideoOverlayService,
    RouteAnimationsService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
